import DatagridProducers from '@/producers/components/datagrid'
import {producerExporter} from '@/producers/utils/exporters'
import {Alert, AlertTitle} from '@mui/material'
import * as React from 'react'
import {Fragment, useEffect} from 'react'
import {AutocompleteArrayInput, BooleanInput, List, NumberInput, Pagination, ReferenceArrayInput, SearchInput, SelectInput} from 'react-admin'

export default function ProducerList() {
	return (
		<>
			<Alert severity="info" style={{width: '100%', marginTop: 20}}>
				<AlertTitle>Structure des données</AlertTitle>
				Les entreprises regroupent les différents établissement qui lui appartiennent (magasins, points de
				vente...), elles ne sont pas affichées sur la carte contrairement aux établissements. Ajoutez une
				entreprise pour ajouter ensuite un établissement !
			</Alert>
			<List
				sort={{field: 'name', order: 'ASC'}}
				perPage={25}
				filters={[
					<SearchInput name="q" source="q" alwaysOn/>,
					<BooleanInput name="user_is_validated" source="user_is_validated" label="Compte validé"/>,
					<ReferenceArrayInput
						name="communes"
						label="Communes"
						reference="communes"
						source="communes"
					>
						<AutocompleteArrayInput
							optionText="name"
							optionValue="id"
							debounce={250}
						/>
					</ReferenceArrayInput>,
					<SelectInput 
						name="administrative_status" 
						source="administrative_status" 
						label="Statut administratif"
						choices={[
							{id: 'A', name: 'Actif'},
							{id: 'C', name: 'Cessée'}
						]}
					/>,
					<BooleanInput name="is_validated" source="is_validated" label="Validé"/>,
					<BooleanInput name="is_published" source="is_published" label="Publié"/>,
					<NumberInput name="ca_min" source="ca_min" label="CA minimum (€)"/>,
					<NumberInput name="ca_max" source="ca_max" label="CA maximum (€)"/>,
					<NumberInput name="capital_social_min" source="capital_social_min" label="Capital social min (€)"/>,
					<NumberInput name="capital_social_max" source="capital_social_max" label="Capital social max (€)"/>
				]}
				exporter={producerExporter}
			>
				<TableList/>
			</List>
		</>
	)
}

const TableList = () => {

	useEffect((): any => {
		document.title = 'Producteurs'
	}, [])

	return (
		<Fragment>
			<Pagination rowsPerPageOptions={[5, 10, 25]}/>
			<DatagridProducers/>
		</Fragment>
	)
}
